import React from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { SVG, SVGIcon } from '../../../../components/atoms/SVG';

export function Icon({ icon, modifier }: { icon: SVGIcon; modifier?: Modifier<'green' | 'margin-right'> }) {
  return (
    <span className={bem('status-info__icon', modifier)} aria-hidden="true">
      <SVG svgSpriteId={icon} />
    </span>
  );
}
